import React, { Suspense } from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import type { StackScreenProps } from "@react-navigation/stack";
import { ExposureProvider, ExposureStackParamList } from "./ExposureContext";
import { ExposureTypesScreen } from "./screens/ExposureTypesScreen";
import { ExposureDetailsScreen } from "./screens/ExposureDetailsScreen";
import { ExposureCompleteScreen } from "./screens/ExposureCompleteScreen";
import { View } from "react-native";
import { MedicalHistoryQuestionProvider } from "@src/packages/medical-history/components";

export type ExposureStackScreenProps<T extends keyof ExposureStackParamList> =
  StackScreenProps<ExposureStackParamList, T>;

const Stack = createNativeStackNavigator<ExposureStackParamList>();

export default function ExposureNavigator() {
  return (
    <Suspense fallback={<View testID="screen-loading" />}>
      <ExposureProvider>
        <MedicalHistoryQuestionProvider
          section="exposure"
          sectionLabelKey="med_history.review.section_title.exposure"
          helpTextKey="med_history.question_screen.flow_help.exposure"
        >
          <Stack.Navigator
            screenOptions={{
              headerShown: false,
              contentStyle: { backgroundColor: "transparent" },
            }}
          >
            <Stack.Screen
              name="ExposureTypes"
              component={ExposureTypesScreen}
            />
            <Stack.Screen
              name="ExposureDetails"
              component={ExposureDetailsScreen}
            />
            <Stack.Screen
              name="ExposureComplete"
              component={ExposureCompleteScreen}
            />
          </Stack.Navigator>
        </MedicalHistoryQuestionProvider>
      </ExposureProvider>
    </Suspense>
  );
}
